import { DocumentData } from "@king-ict/eupisi-ui/models";

import { ProgramRequestDetail, ExecutionResolutionDocument, ProgramRequestStatusHistory, createProgramRequestDetailInitial } from ".";

/** maps to a NewProgramRequestDto */
export interface ProgramRequest {
  id: number;
  institutionId: number;
  requestCode: string;
  requestCreator: string;
  creatorUserName: string;
  requestDate: Date;
  programDate: Date;
  requestStatusId: number;
  requestStatus: string;
  programTypeId: number;
  programTypeName: string;
  isEditable: boolean;
  /** maps to a NewProgramRequestDetailDto */
  programRequestDetail: ProgramRequestDetail;
  /** maps to a NewProgramRequestDetailDto */
  programRequestDetailCopy?: ProgramRequestDetail;
  programRequestResolutions: ExecutionResolutionDocument[];
  programRequestStatusHistorys: ProgramRequestStatusHistory[];
}

export const createProgramRequestInitial = (): ProgramRequest => {
  return {
    id: 0,
    institutionId: 0,
    requestCode: "",
    requestCreator: "",
    creatorUserName: "",
    programTypeId: 0,
    programTypeName: "",
    isEditable: true,
    requestDate: new Date(),
    programDate: new Date(),
    requestStatusId: 0,
    requestStatus: "",
    programRequestDetail: createProgramRequestDetailInitial(),
    programRequestResolutions: [],
    programRequestStatusHistorys: []

  };
}